import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface QuickLinkTile {
    title: string;
    caption: string;
    icon: React.ReactElement;
    color: string;
    bgColor: string;
    borderColor: string;
    onClick: () => void;
}

interface QuickLinksSectionProps {
    tiles: QuickLinkTile[];
    layout?: '1-column' | '3-column';
}

function QuickLinksSection({ tiles, layout = '1-column' }: QuickLinksSectionProps) {
    const theme = useTheme();

    return (
        <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, color: theme.palette.text.secondary }}>
                QuickLinks
            </Typography>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: layout === '1-column' ? '1fr' : 'repeat(3, 1fr)',
                    gap: 2,
                }}
            >
                {tiles.map((tile, index) => (
                    <Box
                        key={index}
                        onClick={tile.onClick}
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            backgroundColor: tile.bgColor,
                            border: `1px solid ${tile.borderColor}`,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            minHeight: 80,
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: theme.shadows[4],
                            },
                        }}
                    >
                        <Box sx={{ color: tile.color, mb: 1 }}>{tile.icon}</Box>
                        <Typography variant="caption" sx={{ color: theme.palette.text.primary, fontWeight: 500 }}>
                            {tile.title}
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{ color: theme.palette.text.secondary, fontSize: '0.65rem', mt: 0.25 }}
                        >
                            {tile.caption}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default QuickLinksSection;
